import { getCurrentColorTheme } from 'src/platform/userPreferences/utils';
import getFullTable from '../entityOperations/getFullTable';
/** Returns value of preference/option from store module preferences.options. That table is fetched on startup from preferences.options DB table */
export default function getOptionValue(id) {
    if (Number(id) === 2)
        return String(getCurrentColorTheme());
    const records = getFullTable('preferences.option_user_values');
    const record = records === null || records === void 0 ? void 0 : records.find((r) => Number(r.option_id) === Number(id));
    const value = record === null || record === void 0 ? void 0 : record.value;
    if (Number(id) === 2)
        debugger;
    return value;
}
